

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 7 12"}, rest), [h('path', {"fill":"currentColor","fill-rule":"nonzero","d":"M2.563 7.865c0-.65.081-1.167.242-1.553.161-.385.48-.809.956-1.27.476-.462.778-.79.905-.985a1.73 1.73 0 0 0 .292-.967c0-.46-.113-.81-.34-1.051-.227-.242-.56-.363-1-.363-.42 0-.758.119-1.014.355-.257.237-.385.558-.385.964H.44c.01-.865.304-1.548.883-2.051C1.901.44 2.666.189 3.618.189c.982 0 1.747.25 2.296.748.55.498.824 1.193.824 2.087 0 .796-.37 1.58-1.113 2.351l-.9.886c-.323.366-.49.901-.499 1.604H2.563Zm-.124 2.278c0-.288.09-.521.271-.7.18-.178.425-.267.732-.267.313 0 .56.092.74.275.18.183.271.414.271.692a.928.928 0 0 1-.264.674c-.175.18-.424.27-.747.27-.322 0-.57-.09-.743-.27a.935.935 0 0 1-.26-.674Z","opacity":".958"}, [])]);
};

        